/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import LoyaltyTerms from './loyalty-terms';
import LoyaltyTermsView from './loyalty-terms.view';

export * from './components';
export * from './loyalty-terms';
export * from './loyalty-terms.data';
export { ILoyaltyTermsConfig, ILoyaltyTermsProps, ILoyaltyTermsResources } from './loyalty-terms.props.autogenerated';
export * from './loyalty-terms.view';

export { LoyaltyTerms, LoyaltyTermsView };
